import { LoLExaminationSection } from '../../Contexts/LoLExaminationProvider/types';
import { Lol_Exam_Result_Type } from '../../generated/graphql';

interface ResultCard {
  title: string;
  subtitle: string;
  type: Lol_Exam_Result_Type;
  tags?: string[];
  conditionNumber: number;
}

export const careerList: ResultCard[] = [
  {
    title: 'POTENTIAL_IDENTITY',
    subtitle: 'POTENTIAL_IDENTITY_SUBTITLE',
    type: Lol_Exam_Result_Type.PotentialIdentityCareer,
    tags: [
      LoLExaminationSection.RIASEC,
      LoLExaminationSection.VALUE,
      LoLExaminationSection.ACTIVITY,
    ],
    conditionNumber: 4,
  },
  {
    title: 'IDENTITY',
    subtitle: 'IDENTITY_SUBTITLE',
    type: Lol_Exam_Result_Type.IdentityCareer,
    tags: [
      LoLExaminationSection.RIASEC,
      LoLExaminationSection.VALUE,
      LoLExaminationSection.ACTIVITY,
    ],
    conditionNumber: 4,
  },
  {
    title: 'PERSONALITY',
    subtitle: 'PERSONALITY_SUBTITLE',
    type: Lol_Exam_Result_Type.PersonalityCareer,
    tags: [LoLExaminationSection.RIASEC, LoLExaminationSection.VALUE],
    conditionNumber: 3,
  },
  {
    title: 'PREFERENCE',
    subtitle: 'PREFERENCE_SUBTITLE',
    type: Lol_Exam_Result_Type.PreferencesCareer,
    tags: [LoLExaminationSection.RIASEC, LoLExaminationSection.ACTIVITY],
    conditionNumber: 4,
  },
  {
    title: 'CAPABLE',
    subtitle: 'CAPABLE_SUBTITLE',
    type: Lol_Exam_Result_Type.CapableCareer,
    tags: [LoLExaminationSection.RIASEC],
    conditionNumber: 2,
  },
];

export const coreTraitList: ResultCard[] = [
  {
    title: 'FIRST_VALUE',
    subtitle: 'FIRST_VALUE_SUBTITLE',
    type: Lol_Exam_Result_Type.FirstValue,
    tags: [LoLExaminationSection.VALUE],
    conditionNumber: 2,
  },
  {
    title: 'SECOND_VALUE',
    subtitle: 'SECOND_VALUE_SUBTITLE',
    type: Lol_Exam_Result_Type.SecondValue,
    tags: [LoLExaminationSection.VALUE],
    conditionNumber: 2,
  },
  {
    title: 'THIRD_VALUE',
    subtitle: 'THIRD_VALUE_SUBTITLE',
    type: Lol_Exam_Result_Type.ThirdValue,
    tags: [LoLExaminationSection.VALUE],
    conditionNumber: 2,
  },
  {
    title: 'FIRST_RIASEC',
    subtitle: 'FIRST_RIASEC_SUBTITLE',
    type: Lol_Exam_Result_Type.FirstRiasec,
    tags: [LoLExaminationSection.RIASEC],
    conditionNumber: 1,
  },
  {
    title: 'SECOND_RIASEC',
    subtitle: 'SECOND_RIASEC_SUBTITLE',
    type: Lol_Exam_Result_Type.SecondRiasec,
    tags: [LoLExaminationSection.RIASEC],
    conditionNumber: 1,
  },
  {
    title: 'FIRST_STRENGTH',
    subtitle: 'FIRST_STRENGTH_SUBTITLE',
    type: Lol_Exam_Result_Type.FirstStrength,
    tags: [LoLExaminationSection.STRENGTH],
    conditionNumber: 4,
  },
  {
    title: 'SECOND_STRENGTH',
    subtitle: 'SECOND_STRENGTH_SUBTITLE',
    type: Lol_Exam_Result_Type.SecondStrength,
    tags: [LoLExaminationSection.STRENGTH],
    conditionNumber: 4,
  },
  {
    title: 'THIRD_STRENGTH',
    subtitle: 'THIRD_STRENGTH_SUBTITLE',
    type: Lol_Exam_Result_Type.ThirdStrength,
    tags: [LoLExaminationSection.STRENGTH],
    conditionNumber: 4,
  },
];
